import NotFound from "../components/NotFound";

const NotFoundView = () => {
  return <NotFound />;
};

export default NotFoundView;
